export default __webpack_public_path__ + "static/media/quickGuideInstructions.ec54b734.png";